import {
  sendIntegrationMail,
  sendSupportMail,
} from "../../utils/builder/IModelsTree";
import {
  loggedIn,
  loginButton,
  logout,
  getUserData,
  deleteUserData,
  setUserData,
} from "../../utils/builder/IUsers";
import { STATUS, DELETE_USER, USER_INFO } from "../constans/index";
import { logError } from "../../utils/builder/IAmecLog";

export const signInAtcion = () => async (dispatch) => {
  try {
    await loginButton();
  } catch (err) {
    logError("FrontEnd.src.store.actions.user.signInAtcion", err.toString());
  }
};

export const signOut = () => async (dispatch) => {
  const hiddenFrame = document.getElementById("hiddenFrame");
  try {
    await logout(hiddenFrame);
  } catch (err) {
    logError("FrontEnd.src.store.actions.user.signOut", err.toString());
  }
};

export const updateUser =
  ({ name, email, phone, company, role }, callback) =>
    async (dispatch) => {
      try {
        //callback((prevState) => ({
        //  signinState: 0,
        //}));
        await setUserData(name, email, phone, company, role);
        const userData = await getUserData();
        dispatch({
          type: USER_INFO,
          payload: userData,
        });
        callback((prevState) => ({
          ...prevState,
          signinState: 1,
        }));
      } catch (err) {
        logError("FrontEnd.src.store.actions.user.updateUser", err.toString());
      }
    };

export const statusCheck = () => async (dispatch) => {
  try {
    const res = await loggedIn();
    dispatch({
      type: STATUS,
      payload: res,
    });
    const userData = await getUserData();
    dispatch({
      type: USER_INFO,
      payload: userData,
    });
  } catch (err) {
    logError("FrontEnd.src.store.actions.user.statusCheck", err.toString());
  }
};

export const deleteUser = () => async (dispatch) => {
  try {
    await deleteUserData();
    await signOut()();
    dispatch({
      type: DELETE_USER,
    });
  } catch (err) {
    logError("FrontEnd.src.store.actions.user.deleteUser", err.toString());
  }
};

export const sendEmail = (email) => async (dispatch) => {
  try {
    await sendIntegrationMail(email);
  } catch (err) {
    logError("FrontEnd.src.store.actions.user.sendEmail", err.toString());
  }
};

export const sendSupportEmail = (email, cantFind, message) => async (dispatch) => {
  try {
    await sendSupportMail(email, cantFind, message);
  } catch (err) {
    logError("FrontEnd.src.store.actions.user.sendEmail", err.toString());
  }
};
